import { ReactElement } from 'react';
import { StyledAnswerContainer, StyledAnswerText } from '../question.styles';

type SavedQuestionProps = {
    id: string;
    text: string;
    questionLabel: string;
    testId?: string;
    editButton?: ReactElement;
};

export const SavedQuestion = ({
    id,
    text,
    questionLabel,
    testId,
    editButton
}: SavedQuestionProps) => (
    <StyledAnswerContainer data-testid={testId}>
        <StyledAnswerText>
            <span id={id}>{questionLabel}</span>
            <strong>{text}</strong>
        </StyledAnswerText>
        {editButton}
    </StyledAnswerContainer>
);
